module.exports = __webpack_public_path__ + "static/media/slider-16.d2305fc0.jpg";